import { forwardRef } from 'react';
import { Spinner as RadixSpinner } from '@radix-ui/themes';
import type { RadixComponentProps } from '@/types/radix-ui';

/**
 * Spinner component - wrapper around Radix UI Spinner
 * Provides all functionality of the original component while allowing
 * for centralized customization and future extensions.
 */
export type SpinnerProps = RadixComponentProps<typeof RadixSpinner>;

const Spinner = forwardRef<HTMLDivElement, SpinnerProps>((props, ref) => {
  return <RadixSpinner ref={ref} {...props} />;
});

Spinner.displayName = 'Spinner';

export { Spinner };
